export default __webpack_public_path__ + "static/media/640_business01-fr-mobile.88ac48ac.png";